<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 表单头部 -->
      <div class="page-card__header">
        修改密码
      </div>

      <!-- 表单内容 -->
      <div class="page-card__body" style="width: 800px; margin: 0 auto">
        <el-form :model="passwordForm" label-width="150px" :rules="rules" ref="passwordForm">
          <el-form-item prop="old_password" label="旧密码：">
            <el-input placeholder="请填写旧密码" v-model="passwordForm.old_password" show-password></el-input>
          </el-form-item>
          <el-form-item prop="password" label="新密码：">
            <el-input placeholder="请填写新密码" v-model="passwordForm.password" show-password></el-input>
          </el-form-item>
          <el-form-item prop="againpassword" label="再输入一次新密码：">
            <el-input placeholder="请再一次填写新密码" v-model="passwordForm.againpassword" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" round @click="updatePassword('passwordForm')">确定修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "password",
    data() {
      return {
        passwordForm: {
          old_password: '',
          password: '',
          againpassword: '',
        },
        rules: {
          old_password: [
            {required: true, message: '请输入旧密码', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
          ],
          againpassword: [
            {required: true, message: '请再次输入新密码', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      // 提交修改密码
      updatePassword(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            if (this.passwordForm.password === this.passwordForm.againpassword) {
              let url = this.baseUrl + '/user/update_password/';
              api.putData(url, {
                old_password: this.passwordForm.old_password,
                password: this.passwordForm.password,
              }).then((res) => {

                if (res.data.detail === '密码修改成功') {

                  this.$message({
                    showClose: true,
                    message: res.data.detail,
                    type: 'success'
                  })
                  this.passwordForm.old_password = '';
                  this.passwordForm.password = '';
                  this.passwordForm.againpassword = '';
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.detail,
                    type: 'warning'
                  })
                }
              })
            } else {
              this.$message({
                message: '两次输入的密码不一致',
                type: 'warning'
              })
            }
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/password.vue